import { render, staticRenderFns } from "./WrittingAnimation.vue?vue&type=template&id=1b1c7cb0"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1c7cb0')) {
      api.createRecord('1b1c7cb0', component.options)
    } else {
      api.reload('1b1c7cb0', component.options)
    }
    module.hot.accept("./WrittingAnimation.vue?vue&type=template&id=1b1c7cb0", function () {
      api.rerender('1b1c7cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WrittingAnimation.vue"
export default component.exports